import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { Root } from "../models/Root";

export class RootRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;

		this.getRoots = this.getRoots.bind(this);
		this.getRootById = this.getRootById.bind(this);
		this.createRoot = this.createRoot.bind(this);
		this.deleteRoot = this.deleteRoot.bind(this);
		this.updateRoot = this.updateRoot.bind(this);
	}

	async getRoots() {
		try {
			const roots = await this.axios.get("/Root/");

			return {
				ok: true,
				roots: roots.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getRootById(rootId: number | null) {
		try {
			const root = await this.axios.get(`/Root/${rootId}`);
			return {
				ok: true,
				root: root.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}

	async createRoot({
		rootId,
		rootName,
		rootTypeId,
		locationId,
		stateComments,
		rootStateId,
		needsAttention,
		attentionComments,
		supervisorInstructions,
		workerComments,
		isActive,
	}: Root) {
		try {
			const resp = await this.axios.post("/Root/", {
				rootId,
				rootName,
				rootTypeId: rootTypeId || 1,
				locationId: locationId || 81,
				stateComments,
				rootStateId: rootStateId || 16,
				needsAttention,
				attentionComments: needsAttention ? attentionComments : "",
				supervisorInstructions,
				workerComments,
				isActive,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
	async updateRoot(rootId: number | null, data: any) {
		try {
			const resp = await this.axios.patch(`/Root/${rootId}`, data);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
	async deleteRoot(rootId: number | null) {
		try {
			await this.axios.delete(`/Root/`, {
				params: { rootId },
			});
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const { getRoots, getRootById, createRoot, updateRoot, deleteRoot } =
	new RootRepository();
